import request from '@/axios'

export function fetchThreadList (customer_id, user_type, query) {
  return request({
    url: `/chat/fetch_user_list/${customer_id}/${user_type}`,
    method: 'GET',
    params:query
  })
}

export function fetch_user_list_general (customer_id, user_type, query) {
  return request({
    url: `/chat/fetch_user_list/${customer_id}/${user_type}`,
    method: 'GET',
    params:query
  })
}

export function fetch_user_list (customer_id, user_type, related_to) {
  return request({
    url: `/chat/v2/fetch_user_list/${customer_id}/${user_type}/${related_to}`,
    method: 'GET'
  })
}


export function get_chat_bar () {
  return request({
    url: '/chat/get_chat_bar',
    method: 'GET'
  })
}

export function fetchChatHistory (payload) {
  return request({
    url: '/chat/fetch_chat_history',
    method: 'POST',
    data: payload
  })
}

export function sendMessage (payload) {
  return request({
    url: '/chat/send_message',
    method: 'POST',
    data: payload
  })
}

export function deleteChatMessage (payload) {
  return request({
    url: '/chat/delete_chat',
    method: 'POST',
    data: payload
  })
}

export function readChatMessage (payload) {
  return request({
    url: '/chat/read_chat',
    method: 'POST',
    data: payload
  })
}

export function createChatGroup (payload) {
  return request({
    url: '/chat/create_group',
    method: 'POST',
    data: payload
  })
}

export function fetchGroupThreads (customer_id, user_type, next_page_url, related_to) {

  let url = ''
  if (next_page_url === null) {
    url =  `/chat/v2/get_group_list/${customer_id}/${user_type}/${related_to}`
  } else {
    url =  `${next_page_url}`
  }

  return request({
    url,
    method: 'GET'
  })
}

export function fetchGroupDetails (group_id) {
  return request({
    url: `/chat/group_details/${group_id}`,
    method: 'GET'
  })
}

export function fetchGroupUserList (customer_id, group_id) {
  return request({
    url: `/chat/group_user_list/${customer_id}/${group_id}`,
    method: 'GET'
  })
}

export function addUserToGroup (payload) {
  return request({
    url: '/chat/add_group_user',
    method: 'POST',
    data: payload
  })
}

export function removeGroupUser (payload) {
  return request({
    url: '/chat/remove_group_user',
    method: 'POST',
    data: payload
  })
}

export function deleteGroup (customer_id, group_id) {
  return request({
    url: `/chat/group_delete/${customer_id}/${group_id}`,
    method: 'GET'
  })
}

export function searchThreadGeneral (customer_id, threadType, keyword) {
  return request({
    url: `/chat/search_user/${customer_id}/${threadType}?search=${keyword}`,
    method: 'GET'
  })
}

export function searchUserThread (customer_id, relatedTo, keyword) {
  return request({
    url: `/chat/v2/search_user/${customer_id}/User/${relatedTo}?search=${keyword}`,
    method: 'GET'
  })
}

export function searchClientThread (customer_id, relatedTo, keyword) {
  return request({
    url: `/chat/v2/search_user/${customer_id}/Client/${relatedTo}?search=${keyword}`,
    method: 'GET'
  })
}
export function searchGroupThread (customer_id, relatedTo, keyword) {
  return request({
    url: `/chat/search_group/${customer_id}/User?search=${keyword}`,
    method: 'GET'
  })
}

export function getRepositoryDetails (customer_id, payload) {
  return request({
    url:`/repository-detail/${customer_id}`,
    method:'POST',
    data:payload
    
  })
}

export function uploadChatFile (customer_id, payload) {
  return request({
    url:`/file/upload/${customer_id}`,
    method:'POST',
    data:payload
    
  })
}

export function addFileUpload (payload) {
  return request({
    url:'/file/upload/add',
    method:'POST',
    data:payload
    
  })
}